import React from "react";
import ReactDOM from "react-dom";
import "src/common/configs/aws";
import "./index.css";
import { Provider } from "react-redux";
import App from "./App";
import { store } from "./app-redux/store";
//import ComingSoon from "./coming";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorker from "./serviceWorker";
import ThankYou from "./ThankYou";

//ReactDOM.render(<ComingSoon />, document.getElementById("root"));
const rootPath = window.location.pathname;
if (rootPath === "/thank-you" || rootPath === "/unsubscribe" || rootPath === "/decline") {
  ReactDOM.render(<ThankYou />, document.getElementById("root"));
} else {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>,
    document.getElementById("root")
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
